/* What "this page" means in a single-page visit. An analytics page owns everything under its own
   address — its drill-downs live there — so the page is the scope, not the exact URL. Any other
   address is scoped to itself alone. */
const ANALYTICS_PAGE_ROOT = /^\/analytics\/pages\/[^/?#]+/u;

const normalizePathname = (value) => {
  const pathname = String(value || '').split(/[?#]/u)[0] || '/';
  return pathname.length > 1 ? pathname.replace(/\/+$/u, '') : pathname;
};

export const resolveSinglePageRoot = (pathname) => {
  const normalized = normalizePathname(pathname);
  const match = ANALYTICS_PAGE_ROOT.exec(normalized);

  return match ? match[0] : normalized;
};

/* Whether an address stays on the pinned page. With no pinned page every address does. */
export const isPathInSinglePage = ({ root, pathname }) => {
  if (!root) {
    return true;
  }

  const normalized = normalizePathname(pathname);

  if (normalized === root) {
    return true;
  }

  return ANALYTICS_PAGE_ROOT.test(root) && normalized.startsWith(`${root}/`);
};
